<template>
	<section>
		<b-navbar v-if="$route.meta.hideMenu" class="htnav is-fixed-top is-dark" :mobile-burger="false">
			<template slot="brand">
				<b-navbar-item class="logo">
					<img src="@/assets/images/logo.png" height="40" alt="HT Auction logo" />
				</b-navbar-item>
			</template>
		</b-navbar>
		<b-navbar v-else class="htnav is-fixed-top is-dark">
			<template slot="brand">
				<b-navbar-item class="logo" tag="router-link" :to="{ path: '/' }" :title="$t('Frontpage')">
					<img src="@/assets/images/logo.png" height="40" alt="HT Auction logo" />
				</b-navbar-item>
			</template>
			<template slot="start">
				<b-navbar-item tag="router-link" :to="{ name: 'Products' }">{{ $t('All products') }}</b-navbar-item>
				<!-- <b-navbar-dropdown :right="true" :title="$t('Categories')"> -->
					<!-- <template slot="label">
						<span class="">{{ $t('Categories') }}</span>
					</template> -->
					<b-navbar-item
					tag="router-link"
					v-for="item in categories"
					:key="item.id"
					:to="{
						name: 'ProductsByCategory',
						params: { maincategory: item.id }
						}"
				>
					<span v-if="lang == 'hu'">{{ item.name }}</span>
					<span v-else>{{ JSON.parse(item.lang)[$i18n.locale] }}</span>
				</b-navbar-item>
				<!-- </b-navbar-dropdown> -->
			</template>

			<template slot="end">
				<b-navbar-item>
					<a href="https://blog.htaukcio.com/" style="color: red; font-weight: bold">Blog</a>
				</b-navbar-item>
				<b-navbar-item
					v-if="wonbids > 0"
					tag="router-link"
					:to="{
						name: 'UserBidsPageTab',
						params: {page: '0', title: $t('user_page.products_won')}
						}"
					:title="$t('user_page.products_won')"
					class="is-hidden-mobile is-hidden-tablet-only"
				>
					<b-icon  :data-badge="wonbids" icon="shopping-cart"></b-icon>
				</b-navbar-item>
				<b-navbar-dropdown v-if="$store.getters.loggedIn == true" :right="true" :title="$t('User')">
					<!-- :label="$store.getters.userid + ' - ' + $store.getters.bidder_name +'('+$store.getters.username+')'" -->
					<template slot="label">
						<span class="is-hidden-desktop">{{ $t('User') }}</span>
						<b-icon icon="user" class="is-hidden-mobile is-hidden-tablet-only"></b-icon>
					</template>
					<b-navbar-item class="navbar-item-username" :disabled="true">
						<strong>{{ $store.getters.bidder_name }}</strong>
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{ name: 'Profile' }">{{ $t('User profile') }}</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{
						name: 'UserBidsPageTab',
						params: {page: '0', title: $t('user_page.products_won')}}">
						{{$t('user_page.products_won')}}
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{
						name: 'UserBidsPageTab',
						params: {page: '1', title: $t('user_page.products_bidded')}}">
						{{$t('user_page.products_bidded')}}
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{
						name: 'UserBidsPageTab',
						params: {page: '2', title: $t('user_page.products_mine')}}">
						{{$t('user_page.products_mine')}}
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{
						name: 'UserBidsPageTab',
						params: {page: '3', title: $t('user_page.products_pay')}}">
						{{$t('user_page.products_pay')}}
					</b-navbar-item>
					<b-navbar-item v-if="$store.getters.role == 100" tag="router-link" :to="{ name: 'ProductUpload' }">
						{{ $t('Product upload (auction)') }}
					</b-navbar-item>
					<b-navbar-item v-if="$store.getters.role == 100" href="/admin" target="_blank">
						{{ $t('Auction admin') }}
					</b-navbar-item>
					<b-navbar-item tag="router-link" :to="{ name: 'Logout' }">{{ $t('Logout') }}</b-navbar-item>
				</b-navbar-dropdown>
				<b-navbar-item v-else tag="router-link" :to="{ name: 'Login' }">{{ $t('Login / Register') }}</b-navbar-item>

				<b-navbar-item v-if="lang == 'hu'" href="#" @click="changeLocale('en')" :title="$t('Switch to English')">
					<img src="@/assets/images/en_GB.png" :alt="$t('English')" />
					<span class="is-hidden-desktop">{{ $t('Switch to English') }}</span>
				</b-navbar-item>
				<b-navbar-item v-else href="#" @click="changeLocale('hu')" :title="$t('Switch to Hungarian')">
					<img src="@/assets/images/hu_HU.png" :alt="$t('Hungarian')" />
					<span class="is-hidden-desktop">{{ $t('Switch to Hungarian') }}</span>
				</b-navbar-item>
			</template>
		</b-navbar>

		<Cmspos position="header"></Cmspos>
	</section>
</template>
<script>
import i18n from '@/lang/lang'
import Cmspos from '@/components/common/Cmspos.vue'

// import TopSearch from "./TopSearch";

export default {
	components: {
		// eslint-disable-next-line vue/no-unused-components
		i18n,
		Cmspos,
	},
	data() {
		return {
			loading: true,
			categories: [],
			wonbids: 0,
			searchString: '',
			lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'hu',
			locale: [{ language: 'en' }, { language: 'hu' }],
			cmspath: [],
		}
	},
	methods: {
		getCategories() {
			var _this = this
			_this.$http.get('/categories').then((response) => {
				_this.categories = response.data.categories
				_this.loading = false
			})
		},
		getWonBids() {
			var _this = this
			if (_this.$store.getters.loggedIn == true) {
				_this.$http.get('/chk/won-bids').then((response) => {
					_this.wonbids = response.data.wonbids
					_this.loading = false
				})
			}
		},
		changeLocale(locale) {
			console.log('LANG:', locale)
			localStorage.setItem('lang', locale.toLowerCase())
			i18n.locale = locale
			this.lang = locale
			this.$moment.locale(locale)
			this.$root.$emit('change_locale', locale)
		},
	},
	mounted() {
		var _this = this
		this.changeLocale(this.lang)
		// this.$store.subscribe((mutation) => {
		// 	if (mutation.type == 'setUser') {
		// 		if (mutation.payload.UserPreference !== undefined) {
		// 			localStorage.setItem('lang', mutation.payload.UserPreference.language.toLowerCase());
		// 			this.lang = mutation.payload.UserPreference.language.toLowerCase();
		// 			this.changeLocale(this.lang);
		// 		}else{
		// 			// logout
		// 		}
		// 	}
		// })
		this.getWonBids()
		this.$root.$on('updateCart', () => {
			_this.getWonBids()
		})
		this.$http.get('/cmspath/', { params: { path: this.$route.fullPath } })
			.then((response) => {
				if (response.data.cms !== undefined) {
					this.cmspath = response.data.cms
				}
				//console.log('********', this.$route.fullPath, response);
			})
			.catch((error) => {
				console.log('get cmspath', error)
			})
		// console.log('USER', this.$store.lang)
		this.getCategories()
		const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)

		// Check if there are any navbar burgers
		if ($navbarBurgers.length > 0) {
			// Add a click event on each of them
			$navbarBurgers.forEach((el) => {
				el.addEventListener('click', () => {
					// Get the target from the "data-target" attribute
					const target = el.dataset.target
					const $target = document.getElementById(target)

					// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
					el.classList.toggle('is-active')
					$target.classList.toggle('is-active')
				})
			})
		}
	},
}
</script>

<style>
.navbar.is-dark .navbar-brand > a.logo,
.navbar.is-dark .navbar-brand > a.logo.router-link-exact-active {
	background-color: white;
}
.navbar.is-dark .navbar-brand > a.logo.navbar-item:hover {
	background-color: lightgray;
}
.navbar.is-dark > .navbar-item > a.router-link-exact-active {
	background-color: #1c0e06;
}
.navbar-item {
	cursor: pointer;
}
</style>
